import axios from 'axios';
import { MinistryTeam } from '../types/ministryTeam';

/**
 * 사역팀 리스트를 DB에서 가져온다.
 * @returns {Promise<MinistryTeam[]>} 사역팀 배열
 */
export const getMinistryTeams = async (): Promise<MinistryTeam[]> => {
  let result: MinistryTeam[] = [];

  try {
    const response = await axios.get(`${process.env.REACT_APP_YCMS_BACKEND_SERVER_URL}/projects/vision2028/ministry-teams`, {
      withCredentials: true,
    });
    result = response.data || [];
  } catch (e) {
    console.error('사역팀 데이터를 가져오는 중 오류 발생:', e.message);
  }

  return result;
};

/**
 * 사역팀을 DB에 추가한다.
 * @param {MinistryTeam} ministryTeam 추가할 사역팀 데이터
 * @returns {Promise<MinistryTeam>} 추가된 사역팀 데이터
 */
export const createMinistryTeam = async (ministryTeam: MinistryTeam): Promise<MinistryTeam> => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_YCMS_BACKEND_SERVER_URL}/projects/vision2028/ministry-teams`, ministryTeam, {
      withCredentials: true,
    });
    return response.data;
  } catch (e) {
    console.error('사역팀 데이터를 추가하는 중 오류 발생:', e.message);
    throw e;
  }
};

/**
 * 사역팀을 DB에서 삭제한다.
 * @param {number} id 삭제할 사역팀의 id
 * @returns {Promise<void>}
 */
export const deleteMinistryTeam = async (id: number): Promise<void> => {
  try {
    await axios.delete(`${process.env.REACT_APP_YCMS_BACKEND_SERVER_URL}/projects/vision2028/ministry-teams/${id}`, {
      withCredentials: true,
    });
  } catch (e) {
    console.error('사역팀 데이터를 삭제하는 중 오류 발생:', e.message);
    throw e;
  }
};

